import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export interface StockLevelChartPoint {
  name: string;
  quantity: number;
  threshold: number;
}

interface StockLevelsChartProps {
  data: StockLevelChartPoint[];
}

export function StockLevelsChart({ data }: StockLevelsChartProps) {
  if (data.length === 0) {
    return (
      <p className="text-muted small mb-0 py-4 text-center">
        Aucune donnée stock à afficher.
      </p>
    );
  }

  return (
    <div className="ph-stock-chart">
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} layout="vertical" margin={{ left: 8, right: 16, top: 8, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#e2e8f0" />
          <XAxis type="number" tick={{ fontSize: 11 }} />
          <YAxis
            type="category"
            dataKey="name"
            width={120}
            tick={{ fontSize: 11 }}
            tickFormatter={(v: string) => (v.length > 18 ? `${v.slice(0, 16)}…` : v)}
          />
          <Tooltip
            formatter={(value: number, name: string) => [
              value,
              name === "quantity" ? "En stock" : "Seuil",
            ]}
            contentStyle={{ fontSize: "0.85rem" }}
          />
          <Bar dataKey="threshold" fill="#fde68a" name="threshold" radius={[0, 4, 4, 0]} />
          <Bar dataKey="quantity" fill="#0d9488" name="quantity" radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
